import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import {
  setSelectedMenu,
  getAvailableAgentList,
} from "../../Redux/Actions/actions";
import { BaseUrlReports } from "../../Container/BaseUrl/BaseUrl";
import axios from "axios";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { TiWarningOutline } from "react-icons/ti";
import FileSaver from "file-saver";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import FilterListIcon from "@mui/icons-material/FilterList";
import { toast } from "react-toastify";
import { toaststyle } from "../../Utils/toaststyle";
import { IoIosArrowBack } from "react-icons/io";
import { DownloadSimple, FunnelSimple } from "@phosphor-icons/react";
import Nodata from "../../Assets/images/svg/Data-unavailable.svg";

import {
  ButtonGroup,
  Button,
  Stack,
  Pagination,
  Typography,
  Box,
  Drawer,
} from "@mui/material";
import { Hourglass } from "react-loader-spinner";
import {
  StyledPaper,
  StyledTableContainer,
  StyledTable,
  StyledTableHead,
  StyledTableBody,
  StyledTableRow,
  StyledTableCell,
  StyledTableCell2,
} from "../../CustomComponent/TableCompoent";

const mapStateToProps = (state) => {
  return {
    selectedMenu: state.contactListData.selectedMenu,
    DropDownAgentList: state.contactListData.DropDownAgentList,
  };
};
const Quaterlyreport = (props) => {
  const selectAgentRef = useRef(null);
  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).getFullYear();
  var someDate = new Date();
  var currentMonth = someDate.getMonth() + 1;

  const [fromYear, setFromYear] = useState(defaultValue);
  const animatedComponents = makeAnimated();
  const [apiCallsMade, setApiCallsMade] = useState(false);
  const [showfilter, setShowFilter] = useState(false);
  const [fromdate, setFromdate] = useState(defaultValue);
  const [todate, setTodate] = useState(defaultValue);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(0);
  const [agentspinner, setagentspinner] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [agentlogindatalist, setAgentLoginDataList] = useState([]);
  const [selectedagent, setSelectedagent] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleMonthChange = (e) => {
    setSelectedMonth(e.target.value);
  };

  const handleYearChange = (e) => {
    setFromYear(e.target.value);
  };

  const yearOptions = [];
  for (let year = new Date().getFullYear(); year >= 1900; year--) {
    yearOptions.push(
      <option key={year} value={year}>
        {year}
      </option>
    );
  }

  const handelShowFilter = () => {
    setShowFilter(true);
  };
  const handelCloseFilter = () => {
    setShowFilter(false);
  };

  const optionsAgent = props.DropDownAgentList.map((agent) => ({
    value: agent.id,
    label: agent.username,
  }));

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      fontSize: "13px",
    }),
  };

  useEffect(() => {
    if (!apiCallsMade) {
      props.getAvailableAgentList();
      setApiCallsMade(true);
    }
  }, [apiCallsMade]);

  useEffect(() => {
    WeeklyReport();
  }, [page]);

  const WeeklyReport = async () => {
    setApiCallsMade(true);
    setagentspinner(true);
    await axios
      .post(
        BaseUrlReports + "api/quarterly_report",
        {
          year: fromYear !== "" ? fromYear : "",
          quarter: selectedMonth !== "" ? selectedMonth : "",
          agent_id: selectedagent.map((option) => option.value),
          tenent_id: localStorage.getItem("TenantId"),
          offset: page == 1 ? 0 : (page - 1) * 10,
          limit: 10,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        setagentspinner(true);
        if (res.data) {
          setagentspinner(false);
          setAgentLoginDataList(res.data.data);
          setPagination(res.data.num);
        } else {
          setagentspinner(false);
          setAgentLoginDataList([]);
          setPagination(0);
        }
      })

      .catch((error) => {
        setagentspinner(false);
        setAgentLoginDataList([]);
        setPagination(0);
      });
  };

  const WeeklyReport1 = async (ToPage1) => {
    setApiCallsMade(true);
    setagentspinner(true);
    await axios
      .post(
        BaseUrlReports + "api/quarterly_report",
        {
          year: fromYear !== "" ? fromYear : "",
          quarter: selectedMonth !== "" ? selectedMonth : "",
          agent_id: selectedagent.map((option) => option.value),
          tenent_id: localStorage.getItem("TenantId"),
          offset: ToPage1,
          limit: 10,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        setagentspinner(true);
        if (res.data) {
          setagentspinner(false);
          setAgentLoginDataList(res.data.data);
          setPagination(res.data.num);
        } else {
          setagentspinner(false);
          setAgentLoginDataList([]);
          setPagination(0);
        }
      })

      .catch((error) => {
        setagentspinner(false);
        setAgentLoginDataList([]);
        setPagination(0);
      });
  };

  const quaterlyReportDataDownload = async () => {
    setIsLoading(true);
    await axios
      .post(
        BaseUrlReports + "api/download_quarterly_report",
        {
          year: fromYear !== "" ? fromYear : "",
          quarter: selectedMonth !== "" ? selectedMonth : "",
          agent_id: selectedagent.map((option) => option.value),
          tenent_id: localStorage.getItem("TenantId"),
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setIsLoading(true);
        if (response.data.status) {
          setIsLoading(false);
          let downloadEmailasPdf =
            BaseUrlReports + "files" + response.data.data.slice(1);
          console.log("downloadEmailasPdf", downloadEmailasPdf);
          window.open(downloadEmailasPdf);

          toast.success("Quaterly Report Downloaded Successfully", toaststyle);
        } else {
          setIsLoading(false);
          toast.warning(response.data.message, toaststyle);
        }
      })

      .catch((error) => {
        setIsLoading(false);
        toast.warning("No Data Found", toaststyle);
      });
  };

  const handleChange = (event, value) => {
    console.log(value);
    setPage(value);
  };

  const handleSelectAgentChange = (selectedOptions) => {
    setSelectedagent(selectedOptions);
  };

  const resetButton = () => {
    selectAgentRef.current.clearValue();
    setFromYear("");
    setSelectedMonth("");
  };

  return (
    // Quarterly Reports start
    <StyledPaper>
      <div className="card Report-card w-100 border-0">
        {/* card-header  */}
        <div
          className="card-header border-0 d-flex align-items-center justify-content-between px-2"
          sx={{ fontWeight: 600, color: "#1473e6" }}
        >
          <div
            className="fw-bold fs-16"
            style={{
              textShadow: "1px 0px 0px #c2c2c27d",
              color: "#0b3363",
            }}
          >
            Quarterly Reports
          </div>
          <div>
            <ButtonGroup
              variant="contained"
              aria-label="button group"
              disableElevation
              size="small"
              sx={{
                textTransform: "capitalize",
              }}
            >
              {/* Back btn  */}
              <Button
                sx={{
                  textTransform: "capitalize",
                }}
                onClick={() => {
                  props.setSelectedMenu("ReportMenu");
                }}
              >
                <IoIosArrowBack className="me-2" />
                Back
              </Button>
              {/* Download btn  */}
              <Button
                sx={{
                  textTransform: "capitalize",
                }}
                onClick={quaterlyReportDataDownload}
                disabled={isLoading}
              >
                <DownloadSimple className="me-2" />
                {isLoading ? "Downloading..." : "Download Report"}
              </Button>
              {/* Filter btn  */}
              <Button
                sx={{
                  textTransform: "capitalize",
                }}
                onClick={handelShowFilter}
              >
                <FunnelSimple className="me-2" />
                Filter
              </Button>
            </ButtonGroup>
          </div>
        </div>
        {/* card-body */}
        <div
          className="card-body p-1 vh-71 box-inset"
          sx={{
            justifyContent: "center",
            display: "flex",
            height: "calc(100% - 40px)",
            display: "flex",
            flexDirection: "column",
            gap: "10",
          }}
        >
          <Box>
            <StyledTableContainer sx={{ height: "26rem !important" }}>
              <StyledTable stickyHeader aria-label="sticky table" size="small">
                <StyledTableHead>
                  <StyledTableRow>
                    {[
                      "Agent Name",
                      "Skillset",
                      "Quater",
                      "Month",
                      "Answered Count",
                      "Lonngest Handling Time",
                      "Total Handling Time",
                      "Average Handling Time",
                    ].map((headers) => (
                      <StyledTableCell style={{ minWidth: "150px" }}>
                        {headers}
                      </StyledTableCell>
                    ))}
                  </StyledTableRow>
                </StyledTableHead>
                <StyledTableBody>
                  {agentspinner ? (
                    <Stack
                      sx={{ position: "absolute", top: "50%", left: "50%" }}
                    >
                      <Hourglass
                        visible={true}
                        height="30"
                        width="30"
                        ariaLabel="hourglass-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        colors={["#2268a0", "#72a1ed"]}
                      />
                    </Stack>
                  ) : agentlogindatalist && agentlogindatalist.length > 0 ? (
                    agentlogindatalist.map((item) => {
                      return (
                        <StyledTableRow hover role="checkbox" tabIndex={-1}>
                          <StyledTableCell2>
                            {item.Agent_name ? item.Agent_name : "--"}
                          </StyledTableCell2>
                          <StyledTableCell2>
                            {item.Skillset ? item.Skillset : "--"}
                          </StyledTableCell2>

                          <StyledTableCell2>
                            {item.Quarter ? item.Quarter : "--"}
                          </StyledTableCell2>

                          <StyledTableCell2>
                            {item.Date ? item.Date : "--"}
                          </StyledTableCell2>

                          <StyledTableCell2>
                            {item.Answered_count ? item.Answered_count : "--"}
                          </StyledTableCell2>

                          <StyledTableCell2>
                            {item.Maximum_answered_time
                              ? item.Maximum_answered_time
                              : "--"}
                          </StyledTableCell2>

                          <StyledTableCell2>
                            {item.Total_answered_time
                              ? item.Total_answered_time
                              : "--"}
                          </StyledTableCell2>
                          <StyledTableCell2>
                            {item.Avg_handling_time
                              ? item.Avg_handling_time
                              : "--"}
                          </StyledTableCell2>
                        </StyledTableRow>
                      );
                    })
                  ) : (
                    // Data unavailable start
                    <Stack
                      sx={{
                        position: "absolute",
                        width: "100%",
                        height: "calc(100vh - 14rem)",
                      }}
                      justifyContent="center"
                      alignContent="center"
                    >
                      <Stack
                        className="text-muted"
                        direction="column"
                        justifyContent="center"
                        alignContent="center"
                      >
                        <span className="mx-auto">
                          <img
                            src={Nodata}
                            alt="pic"
                            style={{ width: "11rem", userSelect: "none" }}
                          />
                        </span>
                        <span className="mx-auto">
                          <h6
                            className="text-muted mt-3"
                            style={{ fontSize: "13px" }}
                          >
                            Data unavailable
                          </h6>
                        </span>
                      </Stack>
                    </Stack>
                    // Data unavailable end
                  )}
                </StyledTableBody>
              </StyledTable>
            </StyledTableContainer>
          </Box>
        </div>
        {/* card-footer */}
        <div className="card-footer border-0">
          <Box>
            <Stack
              sx={{ width: "100%", height: "100%" }}
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              {/* Pagination content  */}
              <Typography variant="caption" sx={{ fontSize: "12px" }}>
                Showing{" "}
                {Math.min(
                  (page - 1) * 10 + 1,
                  isNaN(pagination) ? 0 : pagination
                )}{" "}
                to {Math.min(page * 10, isNaN(pagination) ? 0 : pagination)} of{" "}
                {isNaN(pagination) ? 0 : pagination} entries
              </Typography>
              {/* Pagination  */}
              <Pagination
                count={Math.ceil(pagination / 10)}
                page={page}
                variant="outlined"
                shape="rounded"
                color="primary"
                size="small"
                style={{ float: "right" }}
                onChange={handleChange}
              />
            </Stack>
          </Box>
        </div>
      </div>

      {/* Filters Drawer Start  */}
      <Drawer
        anchor="right"
        open={showfilter}
        onClose={() => {
          setShowFilter(false);
        }}
      >
        <Box style={{ width: "20rem" }}>
          {/* Drawer head start */}
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            className="p-3 shadowDrawer"
          >
            <Typography variant="h3" gutterBottom className="drawer-title">
              Filters
            </Typography>
          </Stack>
          {/* Drawer head end */}
          {/* Drawer Content start */}
          <Stack
            className="p-3"
            style={{ height: "calc(100vh - 7rem)", overflowY: "scroll" }}
          >
            <form className="fs-13">
              <div className="mb-3 d-flex flex-column text-start">
                <label htmlFor="exampleInputfromdate" className="form-label">
                  Select Year <small className="text-danger">*</small>
                </label>
                <select
                  value={fromYear}
                  onChange={handleYearChange}
                  className="form-control fs-13"
                  id="exampleInputfromdate"
                >
                  <option value="">--Select Year--</option>
                  {yearOptions}
                </select>
              </div>
              <div className="mb-3 d-flex flex-column text-start">
                <label htmlFor="exampleInputfromdate" className="form-label">
                  Select Quater <small className="text-danger">*</small>
                </label>
                <select
                  value={selectedMonth}
                  onChange={handleMonthChange}
                  className="form-control fs-13"
                  id="exampleInputfromdate"
                >
                  <option value="">--Select Quater--</option>
                  <option value="Q1">Q1 (Jan-Mar)</option>
                  <option value="Q2">Q2 (Apr-Jun)</option>
                  <option value="Q3">Q3 (Jul-Sep)</option>
                  <option value="Q4">Q4 (Oct-Dec)</option>
                </select>
              </div>

              <div className="mb-3">
                <label for="exampleInputfromdate" className="form-label">
                  Agent <small className="text-danger">*</small>
                </label>
                <Select
                  ref={selectAgentRef}
                  closeMenuOnSelect={true}
                  components={animatedComponents}
                  isMulti
                  options={optionsAgent}
                  placeholder="Select Agent"
                  styles={customStyles}
                  onChange={handleSelectAgentChange}
                  defaultValue={selectedagent}
                  className="fs-13"
                />
              </div>
            </form>
          </Stack>
          {/* Drawer Content end */}
          {/* Drawer footer start */}
          <Stack
            className="p-2"
            sx={{
              position: "absolute",
              bottom: "0",
              background: "#f9f9f9",
              width: "100%",
              boxShadow:
                "rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px",
            }}
            direction="row"
            justifyContent="space-between"
            alignContent="center"
          >
            <Button
              variant="contained"
              className="me-2 w-100"
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              color="error"
              disableElevation
              onClick={handelCloseFilter}
            >
              Close
            </Button>
            <Button
              variant="contained"
              className="me-2 w-100"
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              color="warning"
              disableElevation
              onClick={resetButton}
            >
              Reset
            </Button>
            <Button
              className="w-100"
              variant="contained"
              disableElevation
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              id="session_filter_Submit"
              onClick={() => {
                setPage(1);
                WeeklyReport1(0);
                handelCloseFilter();
              }}
            >
              Submit
            </Button>
          </Stack>
          {/* Drawer footer end */}
        </Box>
      </Drawer>
      {/* Filters Drawer End  */}
    </StyledPaper>
    // Quarterly Reports end
  );
};

export default connect(mapStateToProps, {
  setSelectedMenu,
  getAvailableAgentList,
})(Quaterlyreport);
